import { store } from "@/store/store";
import { eventBus } from "@/eventBus";
import { mapActions, mapGetters, mapMutations } from "vuex";

import firebase from "firebase/app";
import "firebase/auth";

const Poster = {
    data() {
        return {
            placeholder_port: require('@/assets/placeholder-port.svg'),
            placeholder_lands: require('@/assets/placeholder-lands.svg'),
        }
    },
    computed: {
        ...mapGetters(["appConfig", "currentBrowser", "subscriberid"]),
    },
    methods: {
        ...mapActions(["fcmMessagingUnsubscribeToTopic"]),
        ...mapMutations(["setFirebaseUserUID"]),
        getPoster(content, type, from) {
            // debugger;
            if (content?.inwatchlist || content?.poster?.landscape) {
                return content.poster.landscape;
            } else if (from == "TRAILER" && content?.trailer?.poster?.filelist?.[0]?.filename) {
                return content.trailer.poster.filelist[0].filename
            } else if (content?.contentprovider == "CATCHUPTV") {
                return content.thumbnail || this.placeholder_lands;
            } if (Array.isArray(content?.poster)) {
                if (content?.poster?.length) {
                    let index = content?.poster?.findIndex((element) => {
                        return element.postertype === type;
                    });
                    let img = 0;
                    if (index > -1 && Array.isArray(content?.poster?.[index]?.filelist)) {
                        const fileList = content.poster[index].filelist;
                        let preferredOrder = [];
                        if(from == 'slider' || from == 'episode' || from == 'related') {
                            preferredOrder = [...preferredOrder, ...['LOW', 'THUMBNAIL', 'HD', 'SD']];
                        }else if(from == 'carousel' || from == 'detailpage') {
                            preferredOrder = [...preferredOrder, ...['HD', 'SD', 'LOW', 'THUMBNAIL']];
                        }
                        for (const quality of preferredOrder) {
                            const match = fileList?.find(el => el.quality === quality);
                            if (match) {
                                img = match.filename;
                                break;
                            }
                        }

                        if (img) {
                            return img;
                        } else {
                            return type === "LANDSCAPE" ? this.placeholder_lands : this.placeholder_port;
                        }
                    } else {
                        return type === "LANDSCAPE" ? this.placeholder_lands : this.placeholder_port;
                    }

                }
            } else if (content?.thumbnail) {
                return this.placeholder_port;
            } else {
                if (type == "LANDSCAPE") {
                    return this.placeholder_lands;
                }
                return this.placeholder_port;
            }
        },

    },
};

export default Poster;
